import { translateService } from "../services/TranslateService";
import enGB from "./en-gb.json";
import fiFI from "./fi-fi.json";
translateService.registerTranslations("en", enGB);
translateService.registerTranslations("fi", fiFI);
